import { render, staticRenderFns } from "./Medical.vue?vue&type=template&id=76597681&scoped=true&"
import script from "./Medical.vue?vue&type=script&lang=js&"
export * from "./Medical.vue?vue&type=script&lang=js&"
import style0 from "./Medical.vue?vue&type=style&index=0&id=76597681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76597681",
  null
  
)

component.options.__file = "Medical.vue"
export default component.exports